import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
    queueMetaData,
    addIconsToGDTableHeadersList,
} from './configStructure';
import GDTable from 'Components/GDTable';
import EmptyState from 'Components/EmptyState/EmptyState';
import { getTranslations } from 'Containers/OpenQueueLandingPage/configStructure';
import BVLoader20 from 'Components/loaders/BVLoader/BVLoader20';
import { connect } from 'react-redux';
import { fetchDataColumns } from 'Actions/dataColumnsAction';
import {
    dangerNotificationBanner,
    closeNotificationBanner,
} from 'Actions/notificationAction';
import { setCords, resetCords } from 'Actions/floatingPanelAction';
import FloatingPanel from 'Components/FloatingPanel/FloatingPanel';
import {
    formatAvailableFilters,
    formatActiveFilters,
    splitMergedElementIdsFilters,
    mapActiveFilters,
    convertJsonObjectToArray,
    splitMergedElementIdsFilterValues,
    mergeSavedElementIdsForRangeElements,
    mapSavedFilters,
    removeFilterActionSavedFilter,
    splitMergedElementIdsFilterValuesSaveFilter,
} from 'Utils/dynamicListSelectorUtil';
import { exportUserQueueData } from 'Apis/exportApi';
import { openNotificationToast } from 'Utils/notificationMessageUtils.jsx';
import { loadState } from '../../store/browserStorage';
import { getUrlSearchParamValue } from 'Utils/urlUtils';
import {
    getFilterValuesBasedOnElementId,
    getFilterValuesBasedOnElementIdWithAcquirer,
} from 'Apis/caseDataAPI.js';
import classnames from 'classnames';
import FilterPane from 'Components/FilterPane';
import {
    postActiveDynamicFilters,
    postActiveFilterValues,
    getSavedFiltersBasedOnSearchTypeId,
    deleteSavedFilter,
    getFiltersBasedOnSearchTypeId
} from 'Apis/searchFilterApi';
import ResponseBanner from 'Components/cards/ResponseBanner/ResponseBanner.jsx';
import ImagePortal from '../ImagePortal/ImagePortal';
import GDActiveFiltersDropdown from 'Components/GDActiveFiltersDropdown/GDActiveFiltersDropdown';
import LinkInlineButton from 'Components/Button/LinkInlineButton';
import GDNewFilterDropdown from 'Components/GDNewFilterDropdown';
import GDSavedFiltersDropdown from 'Components/GDSavedFiltersDropdown';
import OptionBoxPopup from 'Components/OptionBoxPopup';
import StarIcon from 'Components/icons/StarIcon';
import { postActiveFilters } from 'Apis/caseDataAPI';
import { sort_by } from 'Utils/functionalUtils.js';
import { gotoNewTabCaseLandingPage } from 'Utils/newTabUtils.jsx';
import { downloadFile } from 'Utils/exportFunctionality.js';
import * as KeyConstants from 'Utils/constants/keyConstants.js';
import 'Containers/OpenQueueLandingPage/OpenQueueLandingPage.scss';
import './UnresolvedRTI.scss';
import { setDrawerOpenFlag } from 'Actions/drawerAction';
import GDDetailView from 'Components/GDDetailView';
import ActionPane from 'Containers/ActionPane/ActionPane';
import {
    getAssignedCasesHeaderData,
    getQueueSummary,
    unAssignCase,
    assignCase,
    bulkAssignment,
    assignCasesToGroup,
    postBookMarkCase,
    undoBookMarkCase,
    getAllQueueList,
    fetchFilterValuesBasedOnElementId,
    getUnresovedRTIdata,
    getGroupAnalystDetails
} from 'Apis/queueManagerApi.js';
import {
    getSelectionActionList,
    getActionPanelDetailToShow,
} from './configStructure';
import { getAcquirerAccessList } from 'Utils/permissionsUtils';
import { VITE_UNRESOLVE_RTI_SEARCH_TYPE_ID } from 'Constants/appEnvConstants';
import { each } from 'Utils/lodashUtils';

const DEFAULT_DRAG_OVER_TEXT = 'Drag over to the analyst to assign cases.';
const __NON_UNASSIGNABLE_CASES_QUEUES__ = [66, 67];
const __UNRESOLVE_RTI_PAGE_ID__ = "unresolve_rti";

export class UnresolvedRTI extends Component {
    constructor(props) {
        super(props);
        this.userIdByLogin = getUrlSearchParamValue(this.props.location.search, 'userid');
        this.state = {
            clearSearchTermValue: false,
            isVisible: true,
            filters: [],
            isLoading: true,
            scrollPos: 0,
            totalPages: 0,
            caseData: [],
            totalRecords: 0,
            recordsShown: 0,
            drawerOpen: false,
            currentPage: 0,
            isNextPage: false,
            caseDataErr: false,
            exporting: false,
            filterExportIsVisible: false,
            appliedFilters: [],
            sort: [
                { key: 'actionedDate', order: 1 }
            ],
            dateFormat: queueMetaData().dateFormat,
            filterText: '',
            savedFilterTranslations: {},
            isRequiredFilter: false,
            isTableVisible: false,
            isLoadingComplete: true,
            isRefreshed: false,
            dataColumns: [],
            timeBoxData: {
                date: new Date(),
                isRefreshRequired: true,
                text: 'Last refreshed',
            },
            headerCountData: {},
            queueMetaData: queueMetaData(),
            selectedRows: [],
            bookMarkedRows: [],
            currentGroupAnalysts: [],
            dragOvertText: DEFAULT_DRAG_OVER_TEXT,
            casesToHide: [],
            totalBulkCases: 0,
            resetCaseCount: false,
            totalRecordsUpdated: -1,
            scrollPos: 0,
            activeFiltersValues: [],
            activeFilters: [],
            availableFilters: [],
            isBookMarked: false,
            filterTypeId: 0,
            exportFilterTypeId: 0,
            dropdownToggled: {
                active: false,
                inactive: false,
            },
            finalFilterElements: [],
            apiMultiSelectCount: 0,
            isRequiredFilter: false,
            saveFilterToggled: false,
            filterName: '',
            noSavedFilters: false,
            savedFilters: [],
            currentSearchTerm: '',
            savdActiveFilters: [],
            tempSavedFilters: [],
            queueSearchView: {
                "filterTypeId": 0,
                "searchFilterInputElements": []
            },
            saveFilterFail: false,
            setSize: false,
            sortArr: [
                { key: 'actionedDate', order: 1 }
            ],
            isCurrentlySavedFilters: false,
            dynamicFilterFlag: false,
            formattedFilters: [],
            userIdState: this.userIdByLogin,
            statusErrorCode: 0,
            dropDownBaseQueues: [],
            dropDownSubQueues: [{ focus: true }],
            selectedBaseQueueItem: {},
            selectedSubQueueItem: { text: "Select Queue" },
            acquirerAccessList: [],
            tableName: "Unresolve",
            tableDescription: "Review analyst productivity data including disputes viewed and action",
            actionPanelDetailList: [],
            selectedActionId: 0,
            selectList: [],
            unresolvedRTIAction: false,
        };
        this.attachBindings();
        this.attachListeners();
    }

    attachListeners() {
        // TODO: Add any event lister required.
    }

    attachBindings() {
        this.gotoCaseLandingPage = this.gotoCaseLandingPage.bind(this);
        this.rowActionClick = this.rowActionClick.bind(this);
        this.onRowClick = this.onRowClick.bind(this);
        this.saveCurrentlyVisibleColumns = this.saveCurrentlyVisibleColumns.bind(this);
        this.refreshTimeFeed = this.refreshTimeFeed.bind(this);
        this.fetchHeaderCountData = this.fetchHeaderCountData.bind(this);
        this.getRegionCodeHeaderData = this.getRegionCodeHeaderData.bind(this);
        this.getAssignedCasesHeaderData = this.getAssignedCasesHeaderData.bind(this);
        this.onCheckboxClick = this.onCheckboxClick.bind(this);
        this.unAssignCase = this.unAssignCase.bind(this);
        this.assignCase = this.assignCase.bind(this);
        this.bulkAssignClick = this.bulkAssignClick.bind(this);
        this.onAssignClick = this.onAssignClick.bind(this);
        this.bulkAssignment = this.bulkAssignment.bind(this);
        this.assignCasesToGroup = this.assignCasesToGroup.bind(this);
        this.onKeyDown = this.onKeyDown.bind(this);
        this.setTotalBulkCases = this.setTotalBulkCases.bind(this);
        this.closeFilterPane = this.closeFilterPane.bind(this);
        this.toggleFilterPane = this.toggleFilterPane.bind(this);
        this.resetScrollPos = this.resetScrollPos.bind(this);
        this.updateColumnsInfo = this.updateColumnsInfo.bind(this);
        this.fetchDynamicFilterAccToQueueId = this.fetchDynamicFilterAccToQueueId.bind(this);
        this.saveActiveDynamicFilters = this.saveActiveDynamicFilters.bind(this);
        this.applyFilters = this.applyFilters.bind(this);
        this.onBookMarked = this.onBookMarked.bind(this);
        this.closeBanner = this.closeBanner.bind(this);
        this.toggleDropdown = this.toggleDropdown.bind(this);
        this.deactivateFilter = this.deactivateFilter.bind(this);
        this.clearAllFilters = this.clearAllFilters.bind(this);
        this.toggleSavedFilter = this.toggleSavedFilter.bind(this);
        this.saveFilterName = this.saveFilterName.bind(this);
        this.onChange = this.onChange.bind(this);
        this.updateSearchField = this.updateSearchField.bind(this);
        this.removeSavedFilter = this.removeSavedFilter.bind(this);
        this.setSavedFilterAsActive = this.setSavedFilterAsActive.bind(this);
        this.applySavedFilterSet = this.applySavedFilterSet.bind(this);
        this.closeSaveFilterFailBanner = this.closeSaveFilterFailBanner.bind(this);
        this.getQueueList = this.getQueueList.bind(this);
        this.checkSize = this.checkSize.bind(this);
        this.onKeyPress = this.onKeyPress.bind(this);
        this.getFormattedResponse = this.getFormattedResponse.bind(this);
        this.getMultiSelectFilterValues = this.getMultiSelectFilterValues.bind(this);
        this.updateIsIndeterminate = this.updateIsIndeterminate.bind(this);
        this.getFormattedResponseCorpRegion = this.getFormattedResponseCorpRegion.bind(this);
        this.groupByRegion = this.groupByRegion.bind(this);
        this.clearGroupSearchValue = this.clearGroupSearchValue.bind(this);
        this.onSelectionChange = this.onSelectionChange.bind(this);
        this.resetActionPane = this.resetActionPane.bind(this);
        this.toggleDrawer = this.toggleDrawer.bind(this);
        this.prepopulateFilterValues = this.prepopulateFilterValues.bind(this);
    }

    componentWillMount() {
        scroll(0, 0);
        document.addEventListener('keydown', this.onKeyPres);
        document.addEventListener('keypress', this.onKeyPress);
        const region = getUrlSearchParamValue(this.props.location.search, 'region');
        const queueId = getUrlSearchParamValue(this.props.location.search, 'queueid');
        const userId = getUrlSearchParamValue(this.props.location.search, 'userid');
        const acquirerAccessCode = this.state.acquirerAccessList;
        const customQueueId = getUrlSearchParamValue(this.props.location.search, 'customQueueId');

        const auth = loadState('auth');
        const userPermission = auth.user.parsedPermissions;
        this.setState({
            userPermission,
        });
        let queueMetaDataClone = queueMetaData(userPermission, userId, true);
        this.setState({
            queueMetaData: queueMetaDataClone,
        });
        this.fetchHeaderCountData(this.props.location.search);

        // Fetch columns as per the regional queue and user queue.
        this.setState({
            selectedBaseQueueItem: { id: customQueueId }
        }, () => {
            this.props.fetchDataColumns(__UNRESOLVE_RTI_PAGE_ID__, null,);
            this.fetchDynamicFilterAccToQueueId(VITE_UNRESOLVE_RTI_SEARCH_TYPE_ID, acquirerAccessCode);
        })


    }
    componentDidMount() {
        let acquirerAccessList = getAcquirerAccessList();
        let acquirerAccessCode;
        if (acquirerAccessList.includes('MXP') && !acquirerAccessList.includes('GPN') && !acquirerAccessList.includes('HPY') && !acquirerAccessList.includes('EMD')) {
            acquirerAccessCode = "MXP";
        } else if (acquirerAccessList.includes('GPN') && !acquirerAccessList.includes('MXP') && !acquirerAccessList.includes('HPY') && !acquirerAccessList.includes('EMD')) {
            acquirerAccessCode = "GPN";
        } else if (acquirerAccessList.includes('HPY') && !acquirerAccessList.includes('MXP') && !acquirerAccessList.includes('GPN') && !acquirerAccessList.includes('EMD')) {
            acquirerAccessCode = "HPY";
        }else if (acquirerAccessList.includes('EMD') && !acquirerAccessList.includes('MXP') && !acquirerAccessList.includes('GPN') && !acquirerAccessList.includes('HPY')){
            acquirerAccessCode = "EMD";
        }
         else {
            acquirerAccessCode = null;
        }

        this.setState({
            sort: Object.assign([], [{ key: 'actionedDate', order: 1 }]),
            queueId: getUrlSearchParamValue(this.props.location.search, 'queueid'),
            regionCode: this.state.regionCode != null ? this.state.regionCode : getUrlSearchParamValue(this.props.location.search, 'region'),
            acquirerAccessCode: acquirerAccessCode,
            selectedBaseQueueItemFromUrl: getUrlSearchParamValue(this.props.location.search, 'selectedBaseQueueItem'),
            selectedBaseQueueItem: {
                id: getUrlSearchParamValue(this.props.location.search, 'customQueueId'),
                text: getUrlSearchParamValue(this.props.location.search, 'selectedBaseQueueItem')
            },
            acquirerAccessList: acquirerAccessList
        });

        this.interval = setInterval(() => {
            this.refreshTimeFeed();
        }, 5 * 60 * 1000);

    }
    componentWillUnmount() {
        document.removeEventListener('keydown', this.onKeyPress);
        document.removeEventListener('keypress', this.onKeyPress);
        clearInterval(this.interval);
    }

    getFormattedResponse(response, filter) {
        let filterValues = [];
        response.data.forEach((filterValue) => {
            if (filter === 'un_case_stage') {
                filterValues = filterValues.concat({
                    id: filterValue.stageId,
                    value: filterValue.stageName.trim(),
                    text: filterValue.stageName,
                });
            }
            if (filter === 'un_card_brand') {
                filterValues = filterValues.concat({
                    value: filterValue.cardBrandCode,
                    text: filterValue.cardBrandName,
                });
            }
            if (filter === 'un_analyst_name') {
                filterValues = this.getFormattedResponseCorpRegion(response.data, filter);
                filterValues = this.groupByRegion(filterValues, filter)
            }

        });
        return filterValues;
    }

    getFormattedResponseCorpRegion(corpRegionResponse, filter) {
        let filterValues = [];
        if (filter === 'un_analyst_name') {
            corpRegionResponse.forEach((filterValue, index) => {
                filterValues = filterValues.concat({
                    id: filterValue.firstName + " " + filterValue.lastName,
                    value: filterValue.firstName + " " + filterValue.lastName,
                    text: filterValue.firstName + " " + filterValue.lastName,
                    groupName: filterValue.userGroupName,
                    groupId: filterValue.userGroupName,
                });
            });
        }
        return filterValues;
    }

    groupByRegion(filterlist, filter) {
        let grp = filterlist.reduce((previous, current) => {
            let nameParts = current.groupName;
            if (!previous[nameParts]) {
                previous[nameParts] = [Object.assign({}, current)];
            } else {
                previous[nameParts].push(Object.assign({}, current));
            }
            return previous;
        }, {});
        let group = Object.keys(grp).map(key => ({ key, items: grp[key], cardBrandCode: grp[key][0].cardBrandCode, isIndeterminate: false, selected: false, filterId: filter }));
        this.updateIsIndeterminate(group);
        return group;
    }

    updateIsIndeterminate(filterlist) {
        let that = this;
        each(filterlist, function (analyst) {
            analyst.isIndeterminate = ((!analyst.items.filter(i => {
                return i.selected
            }).length == 0) && (analyst.items.filter(i => {
                return i.selected
            }).length !== analyst.items.length)),
                analyst.selected = analyst.items.filter(i => {
                    return i.selected
                }).length == analyst.items.length
        });
    }

    componentWillUpdate(nextProps, nextState) {
        if (this.state.caseData.length !== nextState.caseData.length || this.state.bookMarkedRows.length == 0) {
            nextState.caseData.map((rowVal, index) => {
                if (rowVal.bookmarkedBy) {
                    this.setState((prevState) => ({
                        bookMarkedRows: prevState.bookMarkedRows.concat(rowVal.caseStageId),
                    }));
                }
            })
        }
    }
    componentWillReceiveProps(nextProps) {
        const region = getUrlSearchParamValue(nextProps.location.search, 'region');
        const queueId = getUrlSearchParamValue(nextProps.location.search, 'queueid');
        const userId = getUrlSearchParamValue(nextProps.location.search, 'userid');
        const acquirerAccessCode = this.state.acquirerAccessCode;

        if (this.props.location !== nextProps.location) {
            this.setState({
                activeFiltersValues: [],
            });
            this.fetchHeaderCountData(nextProps.location.search);
        }
        if (this.props.location !== nextProps.location || this.props.pageId !== nextProps.pageId || this.state?.dataColumns?.length == 0 || this.props?.dataColumns?.length !== nextProps.dataColumns?.length) {
            this.setState({
                dataColumns: addIconsToGDTableHeadersList(nextProps.dataColumns, this.state.userPermission),
                sortArr: Object.assign([], [{ key: 'actionedDate', order: 1 }]),
            }, () => {
                if (!this.state.isCurrentlySavedFilters)
                    this.getDataForDynamicQueueLanding(region, this.state.selectedBaseQueueItem.id, userId, 0, 25, [{ key: 'actionedDate', order: 1 }], this.state.queueSearchView, '', acquirerAccessCode);
            });
            if (this.state.queueId !== queueId) {
                const auth = loadState('auth');
                const userPermission = auth.user.parsedPermissions;
                let queueMetaDataClone = __NON_UNASSIGNABLE_CASES_QUEUES__.find((queueIds) => { return parseInt(queueIds) == parseInt(queueId) }) ? queueMetaData(userPermission, null, true) : queueMetaData(userPermission, this.userIdByLogin, true);
                this.setState({
                    queueMetaData: queueMetaDataClone,
                    queueId: nextProps.queueId,
                    activeFiltersValues: [],
                });
            }
        }

    }

    onKeyPress(event) {
        const eventCode = event.code ? (event.code + '_' + event.ctrlKey) : event.key + '_' + event.ctrlKey;
        switch (eventCode) {
            case KeyConstants.ESCAPE_BUTTON:
            case KeyConstants.ESCAPE_KEY_CODE_BUTTON:
                this.closeBanner();
                this.closeSaveFilterFailBanner();
                break;
        }
    }

    getQueueList() {
        return getAllQueueList()
            .then((apiResponse) => {
                const queueListData = apiResponse.data.sort(sort_by('queueName', false, function (a) { return a.toUpperCase() }));

                this.setState({
                    queueList: queueListData,
                });
            });
    }

    compare(firstAnalyst, nextAnalyst) {
        // Use toUpperCase() to ignore character casing
        const genreA = firstAnalyst.firstName.toUpperCase();
        const genreB = nextAnalyst.firstName.toUpperCase();

        let comparison = 0;
        if (genreA > genreB) {
            comparison = 1;
        } else if (genreA < genreB) {
            comparison = -1;
        }
        return comparison;
    }
    getCaseStageIdList() {
        let stageIdList = [];
        const filterdRecords = this.state.caseData.filter(dataRow => !this.state.casesToHide.includes(dataRow.caseStageId));
        for (let i = 0; i < filterdRecords.length; i++) {
            stageIdList = stageIdList.concat(filterdRecords[i].caseStageId)
        }
        return stageIdList;
    }
    bulkAssignment(bulkAssignData) {
        this.props.closeNotification();
        const analystText = bulkAssignData.caseAssignementBulkDataList.length > 1 ? `analysts` : `analyst`;
        bulkAssignData.caseStageIdList = this.getCaseStageIdList();
        return bulkAssignment(bulkAssignData)
            .then((apiResponse) => {
                const caseNumberText = apiResponse.data.length > 1 ? `${apiResponse.data.length} cases` : `1 case`;
                const haveOrHas = apiResponse.data.length > 1 ? 'have' : 'has';
                const notificationContent = <div style={{ color: 'black' }}>
                    <b>{caseNumberText}</b> {haveOrHas} been successfully assigned to the selected {analystText}.
                </div>

                const notificationMessageSuccess = {
                    type: 'success',
                    placement: 'topRight',
                    messageWidth: 250,
                    byDefault: true,
                    duration: 5,
                    content: notificationContent,
                    onClick: this.onNotificationClick,
                    customActions: [
                        {
                            text: 'Undo',
                            onClick: () => this.bulkUnAssignment(apiResponse.data),
                        }
                    ]
                }
                openNotificationToast(notificationMessageSuccess);

                const assignedCaseList = apiResponse.data.map(caseDetail => {
                    return parseInt(caseDetail.caseStageID)
                });
                const newCasesToHide = this.state.casesToHide.concat(assignedCaseList)
                const totalRecords = this.state.totalRecords;
                const totalRecordsUpdated = totalRecords - newCasesToHide.length;
                this.setState({
                    casesToHide: newCasesToHide,
                    resetCaseCount: true,
                    totalBulkCases: 0,
                    totalRecordsUpdated: totalRecordsUpdated,
                });

            })
            .catch((error) => {

                const notificationMessageError = {
                    type: 'error',
                    placement: 'topRight',
                    messageWidth: 250,
                    byDefault: true,
                    duration: 5,
                    content: <div style={{ color: 'black', paddingTop: 10 }}>
                        <b>System Error</b>: Unable to assign cases to selected {analystText}.
                    </div>
                };
                openNotificationToast(notificationMessageError);
                console.log('Error occured while assigning cases in bulk: ', error);
            });
    }

    bulkAssignClick(items) {
        let casesCount = 0;
        let sourceQueueIdentifier = {};

        const region = getUrlSearchParamValue(this.props.location.search, 'region');
        const queueId = getUrlSearchParamValue(this.props.location.search, 'queueid');
        const userId = getUrlSearchParamValue(this.props.location.search, 'userid');

        if (userId) {
            sourceQueueIdentifier.userID = userId;
        } else {
            sourceQueueIdentifier.queueID = queueId;
            sourceQueueIdentifier.regionCode = region;
        }

        let formattedData = items.filter(userRow => userRow.numberOfRecordsToAssign > 0);

        let caseAssignementBulkDataList = formattedData.map(userRow => {
            return {
                userID: userRow.userId,
                numberOfCases: userRow.numberOfRecordsToAssign,
            }
        });
        let uniqueUsersList = [];
        let filteredCaseAssignment = [];
        caseAssignementBulkDataList.forEach(obj => {
            const unqIndex = caseAssignementBulkDataList.map(function (e) { return e.userID; }).indexOf(obj.userID);
            if (!uniqueUsersList.includes(unqIndex)) {
                uniqueUsersList.push(unqIndex);
                filteredCaseAssignment.push(obj);
                casesCount = casesCount + obj.numberOfCases;
            }
        });
        const bulAssignmentFormattedData = {
            caseAssignementBulkDataList: filteredCaseAssignment,
            ...sourceQueueIdentifier,
        };

        const caseText = casesCount === 1 ? `${casesCount} case` : `${casesCount} cases`
        const descriptionHtml = <div>The system will select the top <b>{caseText}</b> using filters and sorting applied to the case list below, and assign them to the selected analyst{uniqueUsersList.length > 1 ? 's' : ''}.</div>;

        this.props.setNotification([{
            title: `Bulk Assign ${casesCount} Case${casesCount > 1 ? 's' : ''}?`,
            descriptionStyle: "color: 'grey'",
            descriptionHtml: descriptionHtml,
            primaryButtonText: 'ASSIGN THE CASES',
            primaryButtonAction: () => this.bulkAssignment(bulAssignmentFormattedData),
            type: 'info',
            noActions: false,
            closeNotification: () => this.props.closeNotification(),
            cancelButtonText: 'CANCEL',
            valueStyle: "color: 'black'",
        }]);
    }

    onAssignClick = (userData, type) => {
        if (type === 'assignToRegion') {
            const formattedRequestBody = {
                caseStageID: this.state.selectedRows,
                userGroupID: userData.userGroupId,
            };
            this.assignCasesToGroup(this.state.selectedRows, userData, formattedRequestBody);
        }
        if (type === 'assignToUser') {
            const formattedRequestData = this.formatRequestBody(this.state.selectedRows, userData.userId)
            this.assignCase(true, this.state.selectedRows, userData, formattedRequestData);
        }
    }

    bulkUnAssignment(bulkUnAssignmentData) {

        return unAssignCase(bulkUnAssignmentData)
            .then((apiResponse) => {
                const caseNumberText = bulkUnAssignmentData.length > 1 ? `${bulkUnAssignmentData.length} cases` : `1 case`;
                const haveOrHas = bulkUnAssignmentData.length > 1 ? 'have' : 'has';
                const notificationContent = <div style={{ color: 'black' }}>
                    <b>{caseNumberText}</b> {haveOrHas} been unassigned from selected analyst{bulkUnAssignmentData.length > 1 ? 's' : ''}.
                </div>

                const notificationMessageSuccess = {
                    type: 'info',
                    placement: 'topRight',
                    messageWidth: 250,
                    byDefault: true,
                    duration: 5,
                    content: notificationContent,
                }
                openNotificationToast(notificationMessageSuccess);
                const totalRecordsNew = this.state.totalRecordsUpdated + bulkUnAssignmentData.length;
                const newCasesToHide = [];
                this.state.casesToHide.forEach(hcase => {
                    bulkUnAssignmentData.forEach(bcase => {
                        if (bcase.caseStageID !== `${hcase}`) {
                            newCasesToHide.push(hcase);
                        }
                    })
                });
                this.setState({
                    casesToHide: newCasesToHide,
                    totalRecordsUpdated: totalRecordsNew,
                });

            })
            .catch((error) => {
                // TODO: Error Notification on un-Assign Case.
                const notificationMessageError = {
                    type: 'error',
                    placement: 'topRight',
                    messageWidth: 250,
                    byDefault: true,
                    duration: 5,
                    content: <div style={{ color: 'black', paddingTop: 10 }}>
                        <b>System Error</b>: Unable to un-assign selected case{bulkUnAssignmentData.length > 1 ? 's' : ''}.
                    </div>,
                };

                openNotificationToast(notificationMessageError);
                console.log('error occured while un-assigning a case.', error);
            });
    }

    refreshTimeFeed() {
        const region = getUrlSearchParamValue(this.props.location.search, 'region');
        const queueId = getUrlSearchParamValue(this.props.location.search, 'queueid');
        const userId = getUrlSearchParamValue(this.props.location.search, 'userid');
        const acquirerAccessCode = this.state.acquirerAccessCode;

        // API Call
        const timeBoxDataClone = { ...this.state.timeBoxData };
        timeBoxDataClone.date = new Date();
        timeBoxDataClone.isRefreshRequired = true;
        timeBoxDataClone.text = 'Last refreshed';
        this.setState({
            dataColumns: addIconsToGDTableHeadersList(this.state.dataColumns, this.state.userPermission),
            timeBoxData: timeBoxDataClone,
            caseData: [],
            // isRefreshed: true,
            casesToHide: [],
            totalRecordsUpdated: this.state.totalRecords,
            // isLoading:true
        }, () => {
            this.fetchHeaderCountData(this.props.location.search);
            this.getDataForDynamicQueueLanding(region, this.state.selectedBaseQueueItem.id, userId, 0, 25, this.state.sortArr, this.state.queueSearchView, '', acquirerAccessCode);
        });
    }

    getDataForDynamicQueueLanding(regionCode, queueId, userId, pageNumber, size, sortArr, queueSearchView, lazyLoad, acquirerAccessCode) {
        lazyLoad = false;
        const queueMetaDataClone = { ...this.state.queueMetaData };
        queueMetaDataClone.dataColumns = [...this.state.dataColumns];
        return getUnresovedRTIdata(regionCode, VITE_UNRESOLVE_RTI_SEARCH_TYPE_ID, userId, pageNumber, size, sortArr, this.state.queueSearchView, acquirerAccessCode)
            .then((apiResponse) => {
                const formattedData = apiResponse.data.content;
                this.setState((prevState) => ({
                    queueMetaData: queueMetaDataClone,
                    caseData: lazyLoad ? prevState.caseData.concat(formattedData) : formattedData,
                    totalRecords: apiResponse.data.totalElements,
                    totalPages: apiResponse.data.totalPages,
                    currentPage: apiResponse.data.number + 1,
                    recordsShown: size,
                    isNextPage: !apiResponse.data.last,
                    caseDataErr: false,
                    isLoading: false,
                    sortArr,
                    isTableVisible: true,
                    selectedRows: [],
                    agLoader: false,
                    isCurrentlySavedFilters: false,
                    statusErrorCode: apiResponse.status.statusCode,
                }));
                scroll(0, 0);
            })
            .catch((error) => {
                this.setState({ caseDataErr: true, isLoading: false, statusErrorCode: error && error.response && queueId != 69 ? error.response.status : undefined });
                console.log('Error Occured while fetching data', error);
            });
    }

    fetchDynamicFilterAccToQueueId(reportId) {
        let commonArr = [];
        let acquirerAccessList = getAcquirerAccessList();
        this.setState({
            isLoading: true,
        });
        return getFiltersBasedOnSearchTypeId(reportId)
            .then((apiResponse) => {
                let activeFilters = [];
                let availableFilters = [];
                if (apiResponse.status.statusCode === 2000) {
                    apiResponse.data.filterElements.forEach(item => {
                        if (item.elementMandatory) {
                            activeFilters.push(item);
                        } else {
                            availableFilters.push(item);
                        }
                    })
                    this.setState({
                        activeFilters: formatActiveFilters(activeFilters),
                        availableFilters: formatAvailableFilters(availableFilters),
                        filterTypeId: apiResponse.data.filterTypeId,
                        // caseDataErr: false,
                    }, () => {
                        this.getMultiSelectFilterValues();
                        this.fetchSavedFilterValues(this.state.filterTypeId);
                        commonArr = this.state.activeFilters.concat(this.state.availableFilters);
                        commonArr.forEach((filter) => {
                            if (filter.elementTypeName === 'DYNAMIC_MULTISELECT' || filter.elementTypeName === 'GROUP_SEARCH'
                                || filter.elementTypeName === 'SELECT') {
                                if (filter.elementId === 'un_card_brand' && acquirerAccessList) {
                                    getFilterValuesBasedOnElementIdWithAcquirer(filter.elementId, acquirerAccessList)
                                        .then((response) => {
                                            if (response.status.statusCode === 2000) {
                                                let formattedData = this.getFormattedResponse(response, filter.elementId);
                                                this.setState({
                                                    [filter.elementId]: formattedData,
                                                })
                                            }
                                        })
                                        .catch((error) => {
                                            this.setState({
                                                caseDataErr: true,
                                                isLoading: false
                                            })
                                            console.log('Error Occured while fetching filter values based on element id', error);
                                        });
                                }
                                else if (filter.elementId == 'un_analyst_name') {
                                    getGroupAnalystDetails(null, acquirerAccessList)
                                        .then((response) => {
                                            if (response.status.statusCode === 2000) {
                                                let formattedData = this.getFormattedResponse(response, filter.elementId);
                                                this.setState({
                                                    [filter.elementId]: formattedData,
                                                }, () => {
                                                    setTimeout(() => this.getMultiSelectFilterValues(), 300);
                                                })
                                            }
                                        })
                                        .catch((error) => {
                                            this.setState({
                                                caseDataErr: true,
                                                isLoading: false
                                            })
                                            console.log('Error Occured while fetching filter values based on element id', error);
                                        });
                                } else {
                                    getFilterValuesBasedOnElementId(filter.elementId)
                                        .then((response) => {
                                            if (response.status.statusCode === 2000) {
                                                let formattedData = this.getFormattedResponse(response, filter.elementId);
                                                this.setState({
                                                    [filter.elementId]: formattedData,
                                                }, () => {
                                                    setTimeout(() => this.getMultiSelectFilterValues(), 300);

                                                })
                                            }
                                        })
                                        .catch((error) => {
                                            this.setState({
                                                caseDataErr: true,
                                                isLoading: false
                                            })
                                            console.log('Error Occured while fetching filter values based on element id', error);
                                        });
                                }
                            }
                        })
                    });
                }
            })
            .catch((error) => {
                this.setState({ caseDataErr: true, isLoading: false });
                console.log('Error Occured while fetching dynamic filters according to queue id', error);
            })
    }


    getMultiSelectFilterValues() {
        let activeFilters = [];
        activeFilters = this.state.activeFilters.map((filter) => {
            if (filter.elementTypeName === 'DYNAMIC_MULTISELECT' || filter.elementTypeName === 'GROUP_SEARCH' || filter.elementTypeName === 'DROPDOWN') {
                return {
                    filterValues: this.state[filter.elementId],
                    ...filter
                }
            } else {
                return filter;
            }
        });

        let newActiveFilters = activeFilters.map(item => {
            return item
        })

        let notInDynamicFilter = [];
        let dynamicFiltersIds = []
        let firstActiveFilters = newActiveFilters[0]
        newActiveFilters.map(item => { dynamicFiltersIds.push(item.elementId) });
        this.state.formattedFilters.map(item => {
            if (!dynamicFiltersIds.includes(item.elementId)) { notInDynamicFilter.push(item) }
        })
        notInDynamicFilter.map(item => {
            newActiveFilters.push(
                {
                    ...item,
                    actualNameId: item.actualNameId,
                    elementCategoryName: item.elementCategoryName,
                    elementId: item.elementId,
                    elementLabel: item.elementLabel,
                    elementSequenceNumber: item.elementSequenceNumber,
                    elementTypeName: item.elementTypeName,
                    elementValue: item.elementValue,
                    filterValues: item.filterValues,
                    savedSearchId: firstActiveFilters.savedSearchId,
                    savedSearchParameterId: firstActiveFilters.savedSearchParameterId,
                    updatedId: item.updatedId,
                    isDisabled: item.isDisabled
                }
            )
        })

        this.setState({
            formattedFilters: newActiveFilters,
        }, () => {
            this.handleEventType();
        });
        return activeFilters;
    }

    saveActiveDynamicFilters(activeFilters, newFilterValues, corp, regionCode) {
        const region = this.state.regionCode;
        const userId = getUrlSearchParamValue(this.props.location.search, 'userid');
        const acquirerAccessCode = this.state.acquirerAccessCode;

        let filterTypeId = this.state.filterTypeId;
        let activeFilterValues = newFilterValues;
        let searchFilterInputElements = splitMergedElementIdsFilterValues(activeFilterValues, activeFilters, corp, regionCode).filter(data => data.elementValue !== '');
        let queueSearchView = {
            filterTypeId: filterTypeId,
            searchFilterInputElements: searchFilterInputElements
        };
        this.setState({
            queueSearchView,
            isLoading: true,
            // caseDataErr: false,
        }, () => {
            this.getDataForDynamicQueueLanding(region, this.state.selectedBaseQueueItem.id, userId, 0, 25, this.state.sort, queueSearchView, '', acquirerAccessCode);
        });
        return;
    }

    pageHandler = (newPage, newPerPage) => {
        const region = getUrlSearchParamValue(this.props.location.search, 'region');
        const queueId = getUrlSearchParamValue(this.props.location.search, 'queueid');
        const userId = getUrlSearchParamValue(this.props.location.search, 'userid');
        const acquirerAccessCode = this.state.acquirerAccessCode;

        this.setState({
            isLoading: true,
            // caseDataErr: false,
        });

        const pageSize = newPerPage === undefined ? this.state.recordsShown : newPerPage;
        if (newPage) {
            this.getDataForDynamicQueueLanding(region, this.state.selectedBaseQueueItem.id, userId, newPage - 1, pageSize, this.state.sortArr, this.state.queueSearchView, '', acquirerAccessCode);
        }
    }

    onSearchChange = (filterText) => {
        this.setState({ filterText });
    }

    handleSort = (key, sortArr) => {
        const queueId = getUrlSearchParamValue(this.props.location.search, 'queueid');
        const region = getUrlSearchParamValue(this.props.location.search, 'region');
        const userId = getUrlSearchParamValue(this.props.location.search, 'userid');
        const acquirerAccessCode = this.state.acquirerAccessCode;

        this.setState({
            currentPage: 1,
            agLoader: true,
            isLoading: true,
            // caseDataErr: false,
            sortArr,
        });

        this.getDataForDynamicQueueLanding(region, this.state.selectedBaseQueueItem.id, userId, 0, this.state.recordsShown, sortArr, this.state.queueSearchView, '', acquirerAccessCode);
    }

    toggleFileExport = () => {
        this.setState({ filterExportIsVisible: !this.state.filterExportIsVisible });
    }

    onRowClick = (event, sequenceKey) => {
        if ((!event.target.id &&
            !event.target.classList.contains('gd-row-actions') &&
            !event.target.classList.contains('dropdown-menu-trigger')) ||
            event.target.parentNode.classList.contains('primary')) {
            alert(`Row #${sequenceKey} clicked.`); // eslint-disable-line
        }
    }

    rowActionClick(selectedKeyIndex, key) {
        this.setState({
            selectedKeyIndex,
            caseNumber: this.state.caseData[selectedKeyIndex].caseNumber,
            caseStageId: this.state.caseData[selectedKeyIndex].caseStageId,
            productivityActivityLogId: this.state.caseData[selectedKeyIndex].productivityActivityLogId,
            caseStage:this.state.caseData[selectedKeyIndex].caseStage,
            cardBrandCode : this.state.caseData[selectedKeyIndex].cardBrandCode,
            recordTypeIdentifier : this.state.caseData[selectedKeyIndex].recordTypeIdentifier
        });

        if (key === 'OPEN_CASE') {
            this.gotoCaseLandingPage(selectedKeyIndex);
        }
        if (key === 'UNRESOLVE_RTI') {
            this.setState({
                isVisible: false,
                selectList: getSelectionActionList(),
                actionPanelDetailList: getActionPanelDetailToShow(),
                onCloseClick: false,
            }, () => {
                this.onSelectionChange();
            });
        }
        if (key === "DETAIL_DRAWER") {
            this.setState({
                drawerOpen: true,
                selectedKeyIndex,
              });
              this.props.setDrawerOpenFlag(true);
        }
        if (key === "OPEN_CASE_IN_TAB") {
            gotoNewTabCaseLandingPage(this.state.caseData[selectedKeyIndex].caseNumber);
        }
        if (key === 'UNASSIGN_CASE') {
            const formattedRequestData = this.formatRequestBody([this.state.caseData[selectedKeyIndex].caseStageId], this.state.caseData[selectedKeyIndex].caseAssignTo)
            this.unAssignCase(true, [this.state.caseData[selectedKeyIndex].caseStageId], this.state.selectedQueueData, formattedRequestData);
        }
    }
    toggleDrawer = () => {
        document.body.style.overflow = 'visible';
        this.props.setDrawerOpenFlag(false);
        this.setState({
          drawerOpen: !this.state.drawerOpen,
        });
    }
    // eslint-disable-next-line no-undef
    goToNextRecord = () => {
        this.state.selectedKeyIndex + 1 < this.state.caseData.length && this.setState((prevState) => ({
        selectedKeyIndex: prevState.selectedKeyIndex + 1,
        }));
    };

    // eslint-disable-next-line no-undef
    goToPreviousRecord = () => {
        this.state.selectedKeyIndex > 0 && this.setState((prevState) => ({
        selectedKeyIndex: prevState.selectedKeyIndex - 1,
        }));
    };

    prepopulateFilterValues(selectedKeyIndex) {
        const rowData = this.state.caseData[selectedKeyIndex];
        const structure = [].concat(this.state.structureMetaData);
        const filterList = this.state.structureMetaData.caseSelectionConfig.searchFilters;
        let newValue;
        const newValues = [];
        filterList.map((filter) => {
        let data;
        structure.map((row) => {
            row.dataColumns?.forEach((item) => {
            if (filter.columnKey === item.columnKey) {
                data = rowData[`${item.columnKey}`];
                newValue = Object.assign({}, {
                [filter.reportFilterId]: { v1: data },
                });
                newValues.push(newValue);
            } else {
                newValue = Object.assign({}, {
                [filter.reportFilterId]: { v1: '' },
                });
            }
            },
            );
        });
        });
        this.setState({ prePopulatedFilterValues: newValues });
        if ((this.props.location.pathname).indexOf('/caseselection') == -1 || (this.props.location.pathname).indexOf('/imageselection') == -1) {
        this.state.caseData[selectedKeyIndex] && setCaseStageId(this.state.caseData[selectedKeyIndex].caseStageId);
        this.gotoCaseSelectionPage(selectedKeyIndex, newValues);
        }
    }
    onBookMarked(key, caseStageId) {
        const rowData = this.state.caseData[key].caseStageId;
        let presenceIndex = this.state.bookMarkedRows.findIndex(row => row === caseStageId);
        if (rowData) {
            if (presenceIndex === -1) {
                return postBookMarkCase(rowData)
                    .then(() => {
                        this.setState((prevState) => ({
                            bookMarkedRows: prevState.bookMarkedRows.concat(caseStageId),
                        }));
                    })
                    .catch((error) => {
                        console.log('Error Occured while Bookmarking the case', error);
                    });
            }
            else {
                return undoBookMarkCase(rowData)
                    .then(() => {
                        const queueId = getUrlSearchParamValue(this.props.location.search, 'queueid');
                        if (queueId == 70) {
                            this.refreshTimeFeed();
                        }
                        else {
                            this.setState((prevState) => ({
                                bookMarkedRows: prevState.bookMarkedRows.filter(row => row !== caseStageId),
                            }));
                        }
                    })
                    .catch((error) => {
                        console.log('Error Occured while un-bookmarking the case', error);
                    });
            }
        }
    }
    gotoCaseLandingPage(selectedKeyIndex) {
        this.props.history.push({
            state: {
                data: this.state.caseData[selectedKeyIndex],
                prevPath: this.props.location.pathname,
            },
            pathname: '/caselanding/' + `${this.state.caseData[selectedKeyIndex].caseNumber}`,
        });
    }

    saveCurrentlyVisibleColumns(columns) {
        let pageId = __UNRESOLVE_RTI_PAGE_ID__;
        this.setState({
            dataColumns: columns,
        });

        const activeDataColumns = [];
        columns.forEach((column) => {
            if (column.displayType !== 'ICON') {
                const activeColumn = {
                    columnId: column.columnId,
                    displayOrder: column.displayOrder,
                };
                activeDataColumns.push(activeColumn);
            }
        });

        this.postActiveFilters(activeDataColumns, pageId);
    }

    postActiveFilters(columns, pageId) {
        return postActiveFilters(pageId, columns)
            .then(() => {
                this.props.fetchDataColumns(pageId, null,);
                this.setState({
                    // caseDataErr: false,
                    // isLoading: false,
                    isCurrentlySavedFilters: true,
                });
            })
            .catch((error) => {
                this.setState({ caseDataErr: true, isLoading: false });
                console.log('Error Occured while saving active data columns', error);
            });
    }

    toggleFilterPane() {
        document.body.classList.add('instant-header');
        scroll(0, 0);
        this.setState(
            {
                isVisible: !this.state.isVisible,
            },
        );
    }

    // eslint-disable-next-line no-undef
    exportAction = (fileObject) => {
        this.toggleFileExport();
        let isAllColumns = fileObject.exportType.value === 'all-columns' ? true : false;
        let fileType = fileObject.fileType.value;
        let fileName = fileObject.fileName;
        this.state.totalRecords > 25000 ?
            this.setState({
                setSize: true,
            })
            :
            this.exportFile(fileName, fileType, isAllColumns);
    }

    exportFile(fileName, fileType, isAllColumns) {
        const queueId = getUrlSearchParamValue(this.props.location.search, 'queueid');
        const region = this.state.regionCode;
        const userId = getUrlSearchParamValue(this.props.location.search, 'userid');
        let pageId = '';

        if (userId) {
            pageId = 'analyst';
        } else {
            pageId = (queueId == 69 || queueId == 70) ? `queue_mgmt_${queueId}` : `${region.toLowerCase()}_${queueId}`;
        }
        let sortKeyString = [];
        let sortOrderString = [];
        this.state.sortArr.forEach((element) => {
            sortKeyString.push(element.key);
            sortOrderString.push(element.order ? 'ASC' : 'DESC');
        });
        let queueExportData = {
            fileType: fileType,
            isAllColumns: isAllColumns,
            pageId: "unresolve_rti",
            queueManagerUserDataRequest: {
                orderByProperties: sortKeyString,
                pageNumber: 0,
                propertyDirections: sortOrderString,
                size: this.state.totalRecords,
                queueSearchView: {
                    filterTypeId: this.state.exportFilterTypeId,
                    searchFilterInputElements: splitMergedElementIdsFilterValues(this.state.activeFiltersValues).filter(data => data.elementValue !== '')
                },
                regionCode: null,
                queueId: 92,
                userId: userId,
                acquirerAccessCode: this.state.acquirerAccessCode,
            }
        }
        this.setState({ exporting: true });
        exportUserQueueData(queueExportData, null, null).then((response) => {
            downloadFile(fileName, fileType, response);
            this.setState({ exporting: false });
        })
            .catch((error) => {
                this.setState({ exporting: false });
                console.log('Error Occured while exporting the case', error);
            });
    }
    checkSize() {
        this.props.setNotification([{
            title: `Error Occured`,
            descriptionStyle: "color: 'grey'",
            description: 'Your export request has exceeded the limitation of 25,000 rows. Please apply additional filters to reduce of number rows.',
            type: 'danger',
            noActions: true,
            closeNotification: () => this.props.closeNotification(),
        }]);
        this.setState({
            setSize: false,
        })
    }

    fetchHeaderCountData(searchData) {
        const userId = getUrlSearchParamValue(searchData, 'userid');

        if (userId) {
            this.getAssignedCasesHeaderData(userId);
        } else {
            const region = getUrlSearchParamValue(searchData, 'region');
            const queueid = getUrlSearchParamValue(searchData, 'queueid');
            let acquirer = this.state.acquirerAccessCode;
            let acquirerList = [];
            if (acquirer == "MXP") {
                acquirerList = [acquirer, "MXI"];
            } else {
                acquirerList = [acquirer];
            }
        }
    }

    getAssignedCasesHeaderData(userId) {
        return getAssignedCasesHeaderData(userId)
            .then((apiResponse) => {
                this.setState({
                    headerCountData: apiResponse.data,
                });
            })
            .catch((error) => {
                console.log('error fetching assigned cases header count details', error);
            });
    }

    getRegionCodeHeaderData() {
        let item = this.state.selectedBaseQueueItem;
        return getQueueSummary(item.queueGroupCode, item.actionCategoryCode)
            .then((apiResponse) => {
                this.setState({
                    headerCountData: apiResponse.data,
                });
            })
            .catch((error) => {
                console.log('error fetching reason code header count details', error);
            });
    }

    onCheckboxClick(key) {
        this.props.closeNotification();
        if (Array.isArray(key)) {
            this.setState({
                selectedRows: key,
            });
        } else {
            let presenceIndex = this.state.selectedRows.findIndex(row => row === key);
            // Add to selected items or remove if already present.
            this.setState({
                selectedRows: presenceIndex === -1 ? this.state.selectedRows.concat(key) : this.state.selectedRows.filter(row => row !== key),
            });
        }
    }

    assignCasesToGroup(selectedCases, userGroupData, formattedRequestBody) {
        if (selectedCases.length < 1) {
            this.handleCaseSelectionValidation();
        } else {
            const caseNumberText = selectedCases.length > 1 ? `${selectedCases.length} cases` : `Case ${this.state.caseData.find(dataRow => dataRow.caseStageId === selectedCases[0]).caseNumber}`;
            const haveOrHas = selectedCases.length > 1 ? 'have' : 'has';
            return assignCasesToGroup(formattedRequestBody)
                .then((apiResponse) => {

                    // TODO: Sucess Notification on Assign Case.
                    const notificationContent = <div style={{ color: 'black' }}>
                        <b>{caseNumberText}</b> {haveOrHas} been successfully assigned to <b>{userGroupData.key}</b>
                    </div>

                    const notificationMessageSuccess = {
                        type: 'success',
                        placement: 'topRight',
                        messageWidth: 250,
                        byDefault: true,
                        duration: 5,
                        content: notificationContent,
                        onClick: this.onNotificationClick,
                        customActions: [
                            {
                                text: 'Undo',
                                onClick: () => this.unAssignCase(false, selectedCases, userGroupData, apiResponse.data),
                            }
                        ]
                    };

                    openNotificationToast(notificationMessageSuccess);
                    const newCasesToHide = this.state.casesToHide.concat(selectedCases);
                    const totalRecords = this.state.totalRecords;
                    const totalRecordsUpdated = totalRecords - newCasesToHide.length;
                    this.setState({
                        selectedRows: [],
                        casesToHide: newCasesToHide,
                        totalRecordsUpdated: totalRecordsUpdated,
                        displayFloatingPanel: false,
                        dragOvertText: DEFAULT_DRAG_OVER_TEXT,
                        // caseDataErr: totalRecordsUpdated === 0 ? true : false,
                    });
                })
                .catch((error) => {
                    // TODO: Error Notification on un-Assign Case.
                    const notificationMessageError = {
                        type: 'error',
                        placement: 'topRight',
                        messageWidth: 250,
                        byDefault: true,
                        duration: 5,
                        content: <div style={{ color: 'black', paddingTop: 10 }}>
                            <b>System Error</b>: Unable to assign selected case{selectedCases.length > 1 ? 's' : ''}.
                        </div>
                    };
                    openNotificationToast(notificationMessageError);
                    console.log('error occured while assigning a case.', error);
                });
        }
    }


    handleCaseSelectionValidation() {
        this.props.setNotification([{
            title: 'Please select at least one case to assign',
            descriptionStyle: "color: 'grey'",
            type: 'danger',
            cancelButtonText: 'CLOSE',
            cancelOnly: true,
            closeNotification: () => this.props.closeNotification(),
            valueStyle: "color: 'black'",
        }]);
    }

    assignCase(isUndoEnable, selectedCases, userData, formattedRequestData) {

        // TODO: UPDATE when API is integrated.
        if (selectedCases.length < 1) {
            this.handleCaseSelectionValidation();
        } else {
            const userName = `${userData.firstName} ${userData.lastName}`;
            const caseNumberText = selectedCases.length > 1 ? `${selectedCases.length} cases` : `Case ${this.state.caseData.find(dataRow => dataRow.caseStageId === selectedCases[0]).caseNumber}`;
            const haveOrHas = selectedCases.length > 1 ? 'have' : 'has';
            return assignCase(formattedRequestData)
                .then((apiResponse) => {

                    // TODO: Sucess Notification on Assign Case.
                    const notificationContent = <div style={{ color: 'black' }}>
                        <b>{caseNumberText}</b> {haveOrHas} been successfully assigned to <b>{userName}</b>
                    </div>

                    const notificationMessageSuccess = {
                        type: 'success',
                        placement: 'topRight',
                        messageWidth: 250,
                        byDefault: true,
                        duration: 5,
                        content: notificationContent,
                        onClick: this.onNotificationClick,
                        customActions: isUndoEnable ? [
                            {
                                text: 'Undo',
                                onClick: () => this.unAssignCase(false, selectedCases, userData, apiResponse.data),
                            }
                        ] : []
                    };

                    openNotificationToast(notificationMessageSuccess);
                    const newCasesToHide = this.state.casesToHide.concat(selectedCases);
                    const totalRecords = this.state.totalRecords;
                    const totalRecordsUpdated = totalRecords - newCasesToHide.length;
                    this.setState({
                        selectedRows: [],
                        casesToHide: newCasesToHide,
                        totalRecordsUpdated: totalRecordsUpdated,
                        displayFloatingPanel: false,
                        dragOvertText: DEFAULT_DRAG_OVER_TEXT,
                        // caseDataErr: totalRecordsUpdated === 0 ? true : false,
                    });
                })
                .catch((error) => {
                    // TODO: Error Notification on un-Assign Case.
                    const notificationMessageError = {
                        type: 'error',
                        placement: 'topRight',
                        messageWidth: 250,
                        byDefault: true,
                        duration: 5,
                        content: <div style={{ color: 'black', paddingTop: 10 }}>
                            <b>System Error</b>: Unable to assign selected case{selectedCases.length > 1 ? 's' : ''}.
                        </div>,
                    };
                    openNotificationToast(notificationMessageError);
                    console.log('error occured while assigning a case.', error);
                });
        }
    }

    onNotificationClick(clickData) {
    }

    formatRequestBody(selectedCases, userId) {
        return selectedCases.map(selectedCaseStageId => {
            return {
                userID: userId,
                caseStageID: `${selectedCaseStageId}`,
                undo: false,
            }
        });
    }

    unAssignCase(isUndoEnable, selectedCases, userData, formattedRequestBody) {
        this.props.closeNotification();

        return unAssignCase(formattedRequestBody)
            .then((apiResponse) => {
                const userName = userData.firstName === undefined ? userData.key : `${userData.firstName} ${userData.lastName}`;
                const caseNumberText = selectedCases.length > 1 ? `${selectedCases.length} cases` : `Case ${this.state.caseData.find(dataRow => dataRow.caseStageId === selectedCases[0]).caseNumber}`;
                const haveOrHas = selectedCases.length > 1 ? 'have' : 'has';
                // TODO: Sucess Notification on un Assign Case.
                const notificationContent = <div style={{ color: 'black' }}>
                    <b>{caseNumberText}</b> {haveOrHas} been unassigned from <b>{userName}</b>
                </div>

                const notificationMessageSuccess = {
                    type: 'info',
                    placement: 'topRight',
                    messageWidth: 250,
                    byDefault: true,
                    duration: 5,
                    content: notificationContent,
                    customActions: isUndoEnable ? [
                        {
                            text: 'Undo',
                            onClick: () => this.assignCase(false, selectedCases, userData, apiResponse.data),
                        }
                    ] : []
                }
                openNotificationToast(notificationMessageSuccess);
                const totalRecordsNew = this.state.totalRecordsUpdated + selectedCases.length;
                const newCasesToHide = this.state.casesToHide.filter(hcase => !selectedCases.includes(hcase));
                this.setState({
                    casesToHide: newCasesToHide,
                    totalRecordsUpdated: totalRecordsNew,
                });

            })
            .catch((error) => {
                // TODO: Error Notification on un-Assign Case.
                const notificationMessageError = {
                    type: 'error',
                    placement: 'topRight',
                    messageWidth: 250,
                    byDefault: true,
                    duration: 5,
                    content: <div style={{ color: 'black', paddingTop: 10 }}>
                        <b>System Error</b>: Unable to un-assign selected case{selectedCases.length > 1 ? 's' : ''}.
                    </div>,
                };
                openNotificationToast(notificationMessageError);
                console.log('error occured while un-assigning a case.', error);
            });

    }

    onKeyDown(event) {
        if (event.keyCode == 27) {
            this.setState({
                displayFloatingPanel: false,
                selectedRows: [],
            });
        }
    }


    setTotalBulkCases(totalCases) {
        const isCheckboxEnabled = totalCases > 0 ? false : true;
        let queueMetaDataClone = { ...this.state.queueMetaData };
        queueMetaDataClone.isCheckboxOnRowRequired = isCheckboxEnabled;
        this.setState({
            totalBulkCases: totalCases,
            resetCaseCount: false,
            queueMetaData: queueMetaDataClone,
        });
    }

    closeFilterPane = () => {
        scroll(0, 0);
        this.setState({ isVisible: false });
    }

    resetScrollPos() {
        this.setState({
            scrollPos: 0,
        });
    }

    applyFilters(newValues, filterList, corp, region, corpRegion) {
        delete newValues["acquirerCode"];
        this.setState({
            isLoading: true,
        }, () => {
            const newFilterValues = convertJsonObjectToArray(newValues, filterList);
            if (newFilterValues.length === 0) {
                this.setState({
                    isRequiredFilter: true,
                    isVisible: true,
                }, () => {
                    this.handleEventType();
                })
            }
            else {
                this.setState({
                    activeFiltersValues: mapActiveFilters(newFilterValues, filterList),
                    isVisible: false,
                    exportFilterTypeId: this.state.filterTypeId,
                    corp: corp,
                    region: region,
                    corpRegion: corpRegion
                }, () => {
                    this.handleEventType();
                })

                this.saveActiveDynamicFilters(splitMergedElementIdsFilters(filterList), mapActiveFilters(newFilterValues, filterList), corp, region, corpRegion);
                this.getMultiSelectFilterValues();
            }
        })

    }

    updateColumnsInfo(columns) {
        scroll(0, 0);
        this.setState({
            activeFilters: columns.activeColumns,
            availableFilters: columns.availableColumns,
        })
        if (columns.identifier) {
            const newFilterValues = convertJsonObjectToArray(columns.currentValues, columns.filterList);
            this.setState(() => ({
                activeFiltersValues: mapActiveFilters(newFilterValues.filter(data => data && data.id !== columns.identifier), columns.filterList)
            }))
        }
        const finalFilterElements = columns.activeColumns.map((filterElement) => {
            if (filterElement.elementTypeName === 'DYNAMIC_MULTISELECT' || filterElement.elementTypeName === 'GROUP_SEARCH' || filterElement.elementTypeName === 'DROPDOWN') {
                return {
                    filterValues: this.state[filterElement.elementId],
                    ...filterElement,
                };

            } else {
                return filterElement;
            }
        });

        this.setState({
            formattedFilters: finalFilterElements,
            dynamicFilterFlag: true,
        });

    }

    closeBanner() {
        this.setState({
            isRequiredFilter: false,
            //multiSelectFiltersIds
        })
    }
    toggleDropdown(event) {
        event.persist();
        const id = event.currentTarget.id;
        const dropdownToggled = this.state.dropdownToggled;
        dropdownToggled[`${id}`] = !dropdownToggled[`${id}`];
        this.setState({ dropdownToggled });
    }

    deactivateFilter(id) {
        const newFilters = this.state.activeFiltersValues.filter((filter) => {
            return filter.id !== id;
        });
        this.setState(
            {
                activeFiltersValues: mapActiveFilters(newFilters, this.state.activeFilters),
                savedFilters: mapSavedFilters(this.state.savedFilters, newFilters),
            },
            () => {
                this.handleEventType(id);
            }
        );
    }

    clearAllFilters() {
        this.clearGroupSearchValue();
        this.setState(
            {
                clearSearchTermValue: true,
                activeFiltersValues: [],
                savedFilters: mapSavedFilters(this.state.savedFilters),
                queueSearchView: {
                    "filterTypeId": 0,
                    "searchFilterInputElements": []
                },
            }
        );
        this.refreshTimeFeed();
    }

    clearGroupSearchValue() {
        this.state.formattedFilters.map((element) => {
            if (element.elementTypeName === 'GROUP_SEARCH') {
                for (let i = 0; i < element.filterValues?.length; i++) {
                    element.filterValues[i].selected = false;
                    let items = element.filterValues[i].items;
                    for (let j = 0; j < items.length; j++) {
                        items[j].selected = false;
                    }
                }
            }
        })
    }
    saveFilterName() {
        const updateIndex = this.state.savedFilters.findIndex((caseObject) => {
            return caseObject.filterName === this.state.filterName;
        });
        if (updateIndex == -1) {
            return postActiveFilterValues(this.state.filterTypeId, splitMergedElementIdsFilterValuesSaveFilter(this.state.activeFiltersValues, this.state.activeFilters, this.state.corpRegion), this.state.filterName, this.state.selectedBaseQueueItem.id)
                .then((apiResponse) => {
                    if (apiResponse.status.statusCode === 2000) {
                        this.setState({
                            filterName: '',
                            saveFilterToggled: false,
                            // caseDataErr: false,
                            // isLoading: false
                        });
                        this.fetchSavedFilterValues(this.state.filterTypeId);
                    }
                })
                .catch((error) => {
                    this.setState({ caseDataErr: true, isLoading: false, filterName: '' });
                    console.log('Error Occured while saving active filter values with name', error);
                })
        } else {
            this.setState({
                saveFilterFail: true,
                filterName: '',
            });
        }

    }

    fetchSavedFilterValues(filterTypeId) {
        getSavedFiltersBasedOnSearchTypeId(filterTypeId, this.state.selectedBaseQueueItem.id)
            .then((apiResponse) => {
                this.setState({
                    savedFilters: mergeSavedElementIdsForRangeElements(apiResponse.data),
                    noSavedFilters: apiResponse.data.length > 0 ? false : true,
                    tempSavedFilters: apiResponse.data,
                    isLoading: apiResponse.data.length > 0 ? false : this.state.isLoading,
                    // caseDataErr: apiResponse.data.length > 0 ? false : this.state.caseDataErr,
                })
            })
            .catch((error) => {
                this.setState({ isLoading: false, noSavedFilters: true });
                console.log('Error Occured while fetching active filter values', error);
            })
    }

    toggleSavedFilter = () => {
        this.setState({ saveFilterToggled: !this.state.saveFilterToggled });
    };

    onChange(event) {
        if (event.target) {
            this.setState({ [event.target.name]: event.target.value });
        }
    }

    updateSearchField(value) {
        const lowercaseSearchTerm =
            value && value.toLowerCase && value.toLowerCase();
        const filteredFilters = this.state.tempSavedFilters.filter((filter) => {
            // the most redundant, yet appropriate name ever
            const lowercaseFilterName = filter.filterName.toLowerCase();
            return lowercaseFilterName.includes(lowercaseSearchTerm);
        });
        this.setState({
            currentSearchTerm: value,
            savedFilters: mergeSavedElementIdsForRangeElements(filteredFilters),
        });
    }

    removeSavedFilter(id) {
        const newFilters = this.state.savedFilters.filter((filter) => {
            return filter.id !== id;
        });
        this.setState(
            {
                savedFilters: newFilters,
                isOpenSavedFilterDropdown: false,
            },
            () => {
                const body = document.querySelector('body');
                const e = document.createEvent('MouseEvents');
                e.initEvent('mousedown', true, true);
                body.dispatchEvent(e);
            },
        );

        return deleteSavedFilter(id)
            .then((apiResponse) => {
                if (apiResponse.status.statusCode === 2000) {
                    this.fetchSavedFilterValues(this.state.filterTypeId);
                }
            })
            .catch((error) => {
                this.setState({ caseDataErr: true, isLoading: false });
                console.log('error received while deleting filters based on filterId', error);
            });
    }

    setSavedFilterAsActive(id) {
        let index = -1;
        const newFilters = this.state.savedFilters.map((filter) => {
            index++;
            return Object.assign({}, filter, {
                isActive: filter.filterId === id,
            });
        });
        this.setState(
            {
                savedFilters: newFilters,
                isOpenSavedFilterDropdown: false,
            },
            () => {
                const filterSetToUse = this.state.savedFilters.find(
                    (set) => set.isActive,
                );
                this.applySavedFilterSet(filterSetToUse);
            },
        );
    }

    applySavedFilterSet(filterSetToUse) {
        let availFilters = []
        const newActiveFiltersStr = filterSetToUse.filterParams;
        const newActiveFilters = formatActiveFilters(filterSetToUse.activeFilters);
        const newActiveFiltersValues = mapActiveFilters(newActiveFiltersStr, newActiveFilters);

        if (this.state.activeFilters !== undefined) {
            availFilters = removeFilterActionSavedFilter(this.state.availableFilters, this.state.activeFilters, filterSetToUse.filterParams)
            this.setState({
                availableFilters: availFilters
            })
        }

        let dynamicFilters = newActiveFilters.map((filter) => {
            if (filter.elementTypeName === 'DYNAMIC_MULTISELECT' || filter.elementTypeName === 'GROUP_SEARCH' || filter.elementTypeName === 'DROPDOWN') {
                return {
                    ...filter,
                    filterValues: this.state[filter.elementId],
                }
            } else {
                return filter;
            }
        });

        let firstDynamicFilters = dynamicFilters[0]
        let notInDynamicFilter = [];
        let dynamicFiltersIds = []
        dynamicFilters.map(item => { dynamicFiltersIds.push(item.elementId) });
        this.state.formattedFilters.map(item => {
            if (!dynamicFiltersIds.includes(item.elementId)) { notInDynamicFilter.push(item) }
        })
        notInDynamicFilter.map(item => {
            dynamicFilters.push(
                {
                    ...item,
                    actualNameId: item.actualNameId,
                    elementCategoryName: item.elementCategoryName,
                    elementId: item.elementId,
                    elementLabel: item.elementLabel,
                    elementSequenceNumber: item.elementSequenceNumber,
                    elementTypeName: item.elementTypeName,
                    elementValue: item.elementValue,
                    filterValues: item.filterValues,
                    savedSearchId: firstDynamicFilters?.savedSearchId,
                    savedSearchParameterId: firstDynamicFilters?.savedSearchParameterId,
                    updatedId: item.updatedId,
                }
            )

        })

        newActiveFiltersValues.map((filterValue) => {
            if (filterValue.elementType == 'GROUP_SEARCH' && filterValue.v1 && `${filterValue.id}` !== 'corpregion') {
                filterValue.v1 = filterValue.v1.includes(",") ? filterValue.v1.split(',') : [filterValue.v1];
                let dynamicFilterIndex = dynamicFilters.findIndex(dynamicFilter => dynamicFilter.elementId == filterValue.id);
                if (dynamicFilterIndex != -1) {
                    dynamicFilters[dynamicFilterIndex].filterValues.map(groupFilterValue => {
                        groupFilterValue.items.map(groupFilterVal => {
                            if (filterValue.v1.findIndex(v1Val => v1Val == groupFilterVal.id) == -1) {
                                groupFilterVal.selected = false;
                            } else {
                                groupFilterVal.selected = true;
                            }
                        })

                    })
                }
            } else if (filterValue.elementType == 'GROUP_SEARCH' && filterValue.v1 && `${filterValue.id}` === 'corpregion') {
                filterValue.v1 = filterValue.v1.includes(",") ? filterValue.v1.split(',') : [filterValue.v1];
                let dynamicFilterIndex = dynamicFilters.findIndex(dynamicFilter => dynamicFilter.elementId == filterValue.id);
                if (dynamicFilterIndex != -1) {
                    dynamicFilters[dynamicFilterIndex].filterValues.map(groupFilterValue => {
                        groupFilterValue.items.map(groupFilterVal => {
                            for (let index = 0; index < filterValue.value.length; index++) {
                                let region = ''
                                let corp = ''
                                region = JSON.parse(JSON.stringify(filterValue.value[index]))["regionCode"]
                                corp = JSON.parse(JSON.stringify(filterValue.value[index]))["corp"]
                                if (region == groupFilterVal.id && corp == groupFilterVal.groupId) {
                                    groupFilterVal.selected = true
                                    break;
                                } else {
                                    groupFilterVal.selected = false
                                }
                            }
                        })
                    })
                }
            }
        });


        this.setState({
            formattedFilters: dynamicFilters,
            activeFiltersValues: newActiveFiltersValues,
            // activeFilters: newActiveFilters,
            isVisible: true,

        }, () => {
            this.handleEventType();
            const body = document.querySelector('body');
            const e = document.createEvent('MouseEvents');
            e.initEvent('mousedown', true, true);
            body.dispatchEvent(e);
        });
    }

    closeSaveFilterFailBanner() {
        this.setState({
            saveFilterFail: false,
        });
    }

    formatResponseCommon = (response, elementId) => {
        let formattedData = this.getFormattedResponse(response, elementId);
        this.setState({
            [elementId]: formattedData,
        }, () => {
            this.getMultiSelectFilterValues();
        })
    }

    onFilterValueChange = (newValues) => {
        if (newValues?.pr_event_type !== null) {
            this.handleEventType(newValues);
        }

    }

    resetActionPane() {
        this.setState(prevState => {
            return ({
                ...prevState,
                selectedActionPanelDetailItem: {},
                selectedItem: null,
                isDataUploaded: !prevState.isDataUploaded,
                selectedActionId: 0,
                actionViewCode: '',
                unresolvedRTIAction: false,
            });
        }, () => {
            this.refreshTimeFeed;
        });
    }

    onSelectionChange() {
        // Scroll to top when user selects any action from take action dropdown.

        const mainContent = document.getElementsByClassName('main-content');
        mainContent[0].scrollTop = 0;

        let selectedActionId = 0;
        let option = "Unresolve RTI";
        const selectedOption = this.state.selectList.find((item) => item.value === option);
        if (selectedOption != undefined) {
            for (let i = 0; i < this.state.selectList.length; i++) {
                if (selectedOption.text === this.state.selectList[i].text) {
                    this.setState(prevState => ({
                        // selectedActionId: prevState.selectList[i].id,
                        submitActionOption: prevState.selectList[i].value,
                        onCloseClick: true,
                    }));
                    selectedActionId = this.state.selectList[i].id;
                    break;
                }
            }
            if (this.state.selectedActionId != selectedActionId) {
                const selectedActionPanelDetailItem = this.state.actionPanelDetailList.find((actionItem) => actionItem.id === selectedOption.id);
                this.setState({
                    selectedActionPanelDetailItem,
                    actionViewCode: selectedActionPanelDetailItem.viewCode,
                    unresolvedRTIAction: true,
                    selectedActionId,
                    onCloseClick: true,
                });
            }
        }
        this.setState({
            onCloseClick: false
        });
    }

    getSubmitActionStatus = (statusFlag) => {
        this.setState({
            getNextDisableFromAction: statusFlag
        })
    }

    handleEventType = (newValues) => {
        // when called from savedFilters then values will be picked from state formattedFilters
        let valuesInFormatedFilters = this.state.formattedFilters.filter(item => item.elementId == "pr_event_type")[0]?.elementValue;
        let status = newValues?.pr_event_type?.v1 != null ? newValues.pr_event_type?.v1 : valuesInFormatedFilters;
        // when called from applyFilter then values will be picked from state pr_event_typeStatus
        let pr_event_typeStatus = status != null ? status : this.state.pr_event_typeStatus

        let eventActionStatus = newValues == "pr_event_type" ? true : (pr_event_typeStatus != null && pr_event_typeStatus.includes("action") ? false : true)

        let newActiveFilters = this.state.formattedFilters.map(item => {
            if (item.elementId == "pr_action_type") {
                return { ...item, isDisabled: eventActionStatus };
            } else {
                return item;
            }
        })

        this.setState({},
            () => {
                this.setState({
                    formattedFilters: newActiveFilters,
                    pr_event_typeStatus
                });
            }
        )
    }

    unresolvedSearchFilter = () => {
        return (this.state.isVisible && this.props.isSearchActive) ? 'position-fixed__active-dataSearch-unresolved-filter' : 'position-fixed clearfix'
    }

    gridStyles = () => {
        return `queue-mgmt-landing-content ${this.state.isVisible && !this.props.isSearchActive ? "data-search__inactive" : "data-search__active"}`    
    }

    render() {
        window.document.title = 'Unresolve';
        let totalCases = []
        const queueListData = totalCases && totalCases.sort(sort_by('queueName', false, function (a) { return a.toUpperCase() }));

        const queueDataConfig = this.state.queueMetaData;
        const userId = getUrlSearchParamValue(this.props.location.search, 'userid');
        const isChecked = this.state.selectedRows.length > 0 ? true : false;
        const filterdRecords = this.state.caseData.filter(dataRow => !this.state.casesToHide.includes(dataRow.caseStageId));
        const filterPaneTriggerClasses = classnames('filter-pane-trigger', {
            'is-disabled': false,
        });
        let report = Object.assign({}, this.state.queueMetaData);
        report.dataColumns = Object.assign([], this.state.dataColumns);
        const acquirerAccessCode = this.state.acquirerAccessCode;
        if (this.props.user !== undefined && this.props.user.parsedPermissions.queue.viewUnresolvedRTIReport && this.state.statusErrorCode !== 403) {
            return (
                <section className="unresolve-section">
                    {this.state.setSize == true &&
                        this.checkSize()
                    }
                    <FloatingPanel
                        count={this.state.selectedRows.length}
                        text={this.state.dragOvertText}
                    />
                    {this.state.unresolvedRTIAction ? <div className={this.props.isSearchActive && !this.props.unResolvedBannerStatus ? 'main-content--header reports-container--header secondary-header' : ''} style={{ zIndex: 3 }}>
                        {this.state.selectedActionPanelDetailItem && <div style={{ borderTop: 0, width: '100%' }}>
                            <ActionPane
                                getSubmitActionStatus={this.getSubmitActionStatus}
                                caseNumber={this.state.caseNumber}
                                caseStageId={this.state.caseStageId}
                                selectedActionId={this.state.selectedActionId}
                                selectedActionPanelDetailItem={this.state.selectedActionPanelDetailItem}
                                // setNotification={this.props.setNotification}
                                resetActionPane={this.resetActionPane}
                                unresolvedRTIAction={this.state.unresolvedRTIAction}
                                productivityActivityLogId = {this.state.productivityActivityLogId}
                                caseStage = {this.state.caseStage}
                                cardBrandCode = {this.state.cardBrandCode}
                                recordTypeIdentifier = {this.state.recordTypeIdentifier}
                            // closeNotification={this.props.closeNotification}
                            // closeNotification={this.props.closeNotification}
                            // cancelOnly={this.props.cancelOnly}
                            // setCaseStatus={this.setCaseStatus}
                            // isDataUploaded={this.state.isDataUploaded}
                            // cardBrandCode={this.state.caseLandingData.caseStageDetail_cardBrandCode}
                            // resetCaseData={this.resetCaseData}
                            // userName = {this.props.auth.user.firstName + ' ' + this.props.auth.user.lastName}
                            // lastName = {this.props.auth.user.lastName}
                            // userId={this.props.auth.user.userId}
                            />
                        </div>}
                    </div> :
                        <div className={this.props.isSearchActive ? 'main-content--header reports-container--header secondary-header' : "main-content--header reports-container--header"} style={{ zIndex: 3, padding: "0px 24px 0px 12px"}}>

                            <div className="flex-left">
                                <h1 style={{ marginLeft: 10 }}>{this.state.tableName}</h1>
                            </div>

                            <div className="flex-right" style={{ paddingRight: 13 }}>
                                <div className="gd-report-runner__actions">
                                    <div className="gd-report-runner__actions-filters">
                                        <a data-tip data-for="filtering" data-offset="{'right': 320}">
                                            <GDActiveFiltersDropdown
                                                activeFilters={this.state.activeFiltersValues}
                                                dateFormat={this.state.dateFormat}
                                                deactivateFilter={this.deactivateFilter}
                                                dropdownToggled={this.state.dropdownToggled}
                                                filterDefinitions={this.state.activeFilters}
                                                toggleDropdown={this.toggleDropdown}
                                                translations={getTranslations()}
                                                showDynamicFilter={true}
                                            />
                                        </a>
                                    </div>
                                    {this.state.activeFiltersValues.length > 0 && (
                                        <div className="gd-report-runner__actions-clear">
                                            <LinkInlineButton action={this.clearAllFilters}>
                                                Clear All
                                            </LinkInlineButton>
                                            <span>&nbsp;|&nbsp;</span>
                                        </div>
                                    )}
                                    <div className="gd-report-runner__actions-save">
                                        <LinkInlineButton
                                            action={this.toggleSavedFilter}
                                            disabled={this.props.isProvidingSupport}
                                        >
                                            Save
                                        </LinkInlineButton>
                                        {this.state.saveFilterToggled &&
                                            <GDNewFilterDropdown
                                                toggleDropdown={this.toggleSavedFilter}
                                                onChange={this.onChange}
                                                saveFilterName={this.saveFilterName}
                                                translations={getTranslations()}
                                                value={this.state.filterName}
                                            />
                                        }
                                    </div>
                                </div>
                                <div className="gd-filters-dropdown__wrapper gd-report-runner__icon-popup-wrapper">
                                    <OptionBoxPopup
                                        icon={StarIcon}
                                        id="Transaction Search_OptionBoxPopup"
                                        // triggerText="Saved Filters"
                                        showHelpText={getTranslations().savedFilters}
                                    >
                                        <GDSavedFiltersDropdown
                                            noSavedFilters={this.state.noSavedFilters}
                                            onChange={this.updateSearchField}
                                            removeSavedFilter={this.removeSavedFilter}
                                            savedFilters={this.state.savedFilters}
                                            searchTerm={this.state.currentSearchTerm}
                                            setSavedFilterAsActive={this.setSavedFilterAsActive}
                                            translations={getTranslations()}
                                        />
                                    </OptionBoxPopup>
                                </div>
                                <div
                                    role="button"
                                    tabIndex={0}
                                    id="Settled Batches_filter_btn"
                                    className={filterPaneTriggerClasses}
                                    onClick={this.toggleFilterPane}
                                    aria-expanded={this.state.isVisible}
                                >
                                    <span className="gd-report-runner__filter-toggle">Search</span>
                                </div>
                            </div>
                        </div>}

                    <div className="main-content--wrapper" style={{ width: '100%' }}>
                        <div className={this.props.isSearchActive ? '' : 'gd-filter-pane__wrapper'}>
                            <div className={this.unresolvedSearchFilter()} style={{ zIndex: 1 }}>
                                <FilterPane
                                    onFilterValueChange={this.onFilterValueChange}
                                    applyFilters={this.applyFilters}
                                    saveAndApplyFilters={this.saveAndApplyFilters}
                                    closeFilterPane={this.closeFilterPane}
                                    currentValues={this.state.activeFiltersValues}
                                    dateFormat={this.state.dateFormat}
                                    filterList={this.state.formattedFilters}
                                    isVisible={this.state.isVisible}
                                    translations={getTranslations()}
                                    reportName="Unresolved RTI"
                                    extraClass="some-class"
                                    activeFilters={this.state.activeFilters}
                                    resetScrollPos={this.resetScrollPos}
                                    showDynamicFilter={false}
                                    availableFilters={this.state.availableFilters}
                                    updateColumnsInfo={this.updateColumnsInfo}
                                    updateIsIndeterminate={this.updateIsIndeterminate}
                                    clearAllFilters={this.clearAllFilters}
                                    hideMoreLessButton={true}
                                    removeTopMargin={true}
                                />
                            </div>

                        </div>
                        {this.state.caseDataErr && !this.state.isLoading && (
                            <div
                                className="queue-mgmt-empty-state"
                            >
                                <EmptyState
                                    translations={{
                                        emptyStateHeading: 'Data not available.',
                                        emptyStateDescription: 'Please try again later.'
                                    }}
                                />
                            </div>
                        )
                        }
                        {this.state.isRequiredFilter &&
                        <ImagePortal>
                            <ResponseBanner
                                titleStyle={{ color: 'light-green' }}
                                descriptionStyle={{ color: 'grey' }}
                                valueStyle={{ color: 'black' }}
                                title="Validation Error"
                                description="Atleast one field is required for search"
                                type="danger"
                                onClose={this.closeBanner}
                                cancelButtonText="DISMISS"
                                primaryButtonText="OKAY, DO SOMETHING TO FIX IT"
                                primaryButtonAction={this.closeBanner}
                            />
                            </ImagePortal>
                        }

                        {(this.state.isLoading || totalCases === undefined) && <div className="ball-sync-loader loader" style={{ marginTop: "180px", backgroundColor: 'white' }}><BVLoader20 /></div>}
                        <div className="queue-mngmnt-content--wrapper">
                            {this.state.saveFilterFail && <div>
                                <ImagePortal>
                                <ResponseBanner
                                    titleStyle={{ color: 'light-green' }}
                                    descriptionStyle={{ color: 'grey' }}
                                    valueStyle={{ color: 'black' }}
                                    title="Error Occured"
                                    description="Filter name already present. Please enter unique filter name"
                                    type="danger"
                                    onClose={this.closeSaveFilterFailBanner}
                                    cancelButtonText="DISMISS"
                                    primaryButtonActionValue=""
                                    primaryButtonText="OKAY, DO SOMETHING TO FIX IT"
                                    primaryButtonAction={this.closeSaveFilterFailBanner}
                                />
                                </ImagePortal>
                            </div>}

                            {queueDataConfig.displayType == 'gdTable' && !this.state.isLoading && totalCases && !this.state.caseDataErr && <div className={this.gridStyles()} style={this.state.unresolvedRTIAction ? { zIndex: 0, marginTop: -30 } : { zIndex: 0 }} id="UnresolvedRTI" ref={((ref) => (this.gdTable = ref))}>
                                <GDTable
                                    onCloseClick={this.state.onCloseClick}
                                    isAgGrid={true}
                                    isRefreshed={this.state.isRefreshed}
                                    className="queueLandingTable"
                                    report={report}
                                    tableName={this.state.tableName}
                                    tableDescription={this.state.tableDescription}
                                    data={filterdRecords}
                                    dateFormat={this.state.dateFormat}
                                    totalPages={this.state.totalPages}
                                    totalRecords={this.state.totalRecords}
                                    recordsCountText={{ showingRecords: 'Showing records', preposition: 'of' }}
                                    currentPage={this.state.currentPage}
                                    recordsShown={this.state.recordsShown}
                                    sort={this.state.sortArr}
                                    handleSort={this.handleSort}
                                    pageHandler={this.pageHandler}
                                    translations={getTranslations()}
                                    filterText={this.state.filterText}
                                    //onRowClick={this.onRowClick}
                                    isPagable={queueDataConfig.isPagable}
                                    onSearchChange={this.onSearchChange}
                                    isNextPage={this.state.isNextPage}
                                    exporting={this.state.exporting}
                                    exportAction={this.exportAction}
                                    filterExportIsVisible={this.state.filterExportIsVisible}
                                    toggleFileExport={this.toggleFileExport}
                                    actionButtonText="Actions"
                                    rowActionClick={this.rowActionClick}
                                    isLoading={this.state.isLoadingComplete}
                                    saveCurrentlyVisibleColumns={this.saveCurrentlyVisibleColumns}
                                    addIconsToGDTableHeadersList={addIconsToGDTableHeadersList}
                                    titleRequired={queueDataConfig.titleRequired}
                                    timeBoxData={this.state.timeBoxData}
                                    refreshTimeFeed={this.refreshTimeFeed}
                                    //   isCheckboxOnRowRequired={queueDataConfig.isCheckboxOnRowRequired}
                                    recordCountRequired={queueDataConfig.recordCountRequired}
                                    //   showCaseCountDisplay
                                    isFetchingData={false}
                                    //   headerCountDataColumn={userId ? getAnalystHeaderCountDataColumns() : getRegionHeaderCountDataColumns()}
                                    //   headerCountData={this.state.headerCountData}
                                    //   onCheckboxClick={this.onCheckboxClick}
                                    //   selectedRows={this.state.selectedRows}
                                    bookMarkedRows={this.state.bookMarkedRows}
                                    dragOvertText={this.state.dragOvertText}
                                    openBoxDropDownStyle={{ width: 150, marginLeft: -53, fontSize: 'initial', }}
                                    onBookMarked={this.onBookMarked}
                                    agLoader={this.state.agLoader}
                                    userPermissions={this.state.userPermission}
                                    exportFileName={this.state.tableName}
                                    reportName="Unresolved RTI"
                                    isVisible={this.state.isVisible}
                                />

                            </div>}
                            {
              this.state.drawerOpen &&  <div className="drawer open">
                <GDDetailView
                  type="report"
                  data={this.state.caseData[this.state.selectedKeyIndex]}
                  goBack={this.toggleDrawer}
                  goToPreviousRecord={this.goToPreviousRecord}
                  goToNextRecord={this.goToNextRecord}
                  structure={[].concat(this.state.queueMetaData)}
                  preferences={{}}
                  recordCountSize={this.state.caseData.length}
                  selectedKeyIndex={this.state.selectedKeyIndex}
                />              
            </div>
            }
                        </div>
                    </div>
                </section >
            );
        } else {
            return (
                <div className="queue-mgmt-empty-state">
                    <EmptyState
                        translations={{
                            emptyStateHeading: 'You do not have permission to view this page',
                            emptyStateDescription: 'Please contact support team for further assistance.'
                        }}
                    />
                </div>);
        }
    }
}

UnresolvedRTI.propTypes = {
    dataColumns: PropTypes.array.isRequired,
    setNotification: PropTypes.func.isRequired,
    fetchDataColumns: PropTypes.func.isRequired,
    closeNotification: PropTypes.func.isRequired,
    setCords: PropTypes.func.isRequired,
    resetCords: PropTypes.func.isRequired,
    dragOvertText: PropTypes.string,
    onCloseClick: PropTypes.bool,
};

const mapStateToProps = (state) => ({
    dataColumns: state.dataColumns?.columns,
    isSearchActive: state.appSearch.isSearchActive,
    user: state.auth.user,
    unResolvedBannerStatus: state.unResolvedBanner.unResolvedBannerStatus
});

const mapDispatchToProps = (dispatch) => {
    return {
        fetchDataColumns: (pageId, search) => dispatch(fetchDataColumns(pageId, search)),
        setNotification: (banner) => dispatch(dangerNotificationBanner(banner)),
        closeNotification: () => dispatch(closeNotificationBanner()),
        setCords: (cordsData) => dispatch(setCords(cordsData)),
        resetCords: () => dispatch(resetCords()),
        setSearchOpenFlag: (isSearchActive) => {
            dispatch(setSearchOpenFlag(isSearchActive));
        },
        setDrawerOpenFlag: (isDrawerActive) => {
            dispatch(setDrawerOpenFlag(isDrawerActive));
          },
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(UnresolvedRTI);
